<template>
    <header class="topbar">
        <div class="topbar__inner">
            <a href="/assesments" class="brand">
                <span class="brand__logo">&lt;/&gt;</span>
                Entrance Exam
            </a>
            <div class="topbar__user">
                <span class="topbar__hello">Hello, <strong>{{$store.state.auth.name}}</strong></span>
                <button class="btn btn--ghost btn--sm" @click="onLogout">Logout</button>
            </div>
        </div>
    </header>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'ExamineeNavBar',
    methods: {
        onLogout() {
             try{
                    this.$store.dispatch('logout');
                    Vue.$toast.success('Logged Out Successfully')
                    this.$router.push({ name :'login-page'})
                } catch(error){
                    Vue.$toast.error(error.message);
                }
        }
    }
}
</script>
